module.exports = __webpack_public_path__ + "static/media/14.9bafb8a6.jpg";